import { Tractor } from "lucide-react";

export function DozerIcon({ className }: { className?: string }) {
  return <Tractor className={className} />;
}
